import { render, staticRenderFns } from "./PhoneActionButton.vue?vue&type=template&id=7acdf608&scoped=true&lang=pug&"
import script from "./PhoneActionButton.vue?vue&type=script&lang=js&"
export * from "./PhoneActionButton.vue?vue&type=script&lang=js&"
import style0 from "./PhoneActionButton.vue?vue&type=style&index=0&id=7acdf608&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acdf608",
  null
  
)

export default component.exports